import { useFormContext } from 'react-hook-form'
import NavbarPopover from 'components/home/navbar/popovers/components/NavbarPopover'
import classNames from 'classnames'
import { BellIcon } from 'components/icons'
import { DashboardSearchFormFields } from 'data/types/home/search'
import MiniServiceSearch from 'components/modals/home/search/services/MiniServiceSearch'
import NavbarButton from 'components/home/navbar/common/NavbarButton'

interface ServiceSearchPopoverProps {
  className?: {
    container?: string
    button?: string
    panel?: string
  }
  bookingId?: string
}

const ServiceSearchPopover = ({
  className,
}: ServiceSearchPopoverProps) => {
  const { watch, getValues, setValue } = useFormContext<DashboardSearchFormFields>()

  return (
    <NavbarPopover
      trigger={
        <NavbarButton
          prefix={<BellIcon />}
          active={!!watch('search')}
          className={{
            container: 'min-w-[320px] pl-20',
            text: 'flex-1 text-left',
          }}
        >
          {(watch('search') ?? '').length > 0 ? watch('search') : 'What are you looking for?'}
        </NavbarButton>
      }
      variant="fixed"
      className={{
        panel: classNames('px-24 min-w-[830px] flex flex-col items-center top-[calc(100%+2px)] !pt-0', className?.panel),
        button: className?.button,
      }}
    >
      <MiniServiceSearch
        showDisclaimer={false}
        initialSearchTerm={getValues('search')}
        onSearchChange={(term) => setValue('search', term)}
        className={{
          container: 'w-full',
          searchbar: 'pt-15',
          grid: {
            container: 'mt-20',
          },
        }}
      />
    </NavbarPopover>
  )
}

export default ServiceSearchPopover
